import {
  Box,
  Paper,
  TextField,
  Typography,
  Button,
  Stack
} from '@mui/material';
import { useEffect, useState } from 'react';
import { http } from '../../api/http';

interface ContactInfo {
  email?: string;
  phone?: string;
  facebook?: string;
  instagram?: string;
  etsy?: string;
}

export const ContactSettingsPage = () => {
  const [values, setValues] = useState<ContactInfo>({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const res = await http.get<{ success: boolean; data: ContactInfo | null }>(
          '/contact-info'
        );
        if (res.data.data) {
          setValues(res.data.data);
        }
      } catch {
        // ignore
      }
    };
    void fetchInfo();
  }, []);

  const handleChange =
    (field: keyof ContactInfo) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setValues((prev) => ({ ...prev, [field]: e.target.value }));
    };

  const handleSave = async () => {
    setSaving(true);
    try {
      await http.put('/contact-info', values);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Contact Settings
      </Typography>
      <Paper sx={{ p: 3, maxWidth: 600 }}>
        <Stack spacing={2}>
          <TextField
            label="Email"
            value={values.email ?? ''}
            onChange={handleChange('email')}
          />
          <TextField
            label="Phone"
            value={values.phone ?? ''}
            onChange={handleChange('phone')}
          />
          <TextField
            label="Facebook URL"
            value={values.facebook ?? ''}
            onChange={handleChange('facebook')}
          />
          <TextField
            label="Instagram URL"
            value={values.instagram ?? ''}
            onChange={handleChange('instagram')}
          />
          <TextField
            label="Etsy URL"
            value={values.etsy ?? ''}
            onChange={handleChange('etsy')}
          />
          <Box>
            <Button variant="contained" onClick={handleSave} disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

